import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register the service worker.
// onUpdate fires when a new version is available and waiting to activate.
// The App component listens for this via the 'pwa-update-available' event.
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Dispatch a custom event that App.js listens for
    window.dispatchEvent(
      new CustomEvent('pwa-update-available', { detail: { registration } })
    );
  },
  onSuccess: () => {
    console.log('[PWA] App successfully cached for offline use.');
  },
});
